
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

export default {
components: {
Swiper,
SwiperItem
},
data () {
return {
advantagesFirstP: [
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark01.png',
number: '01',
txtH3: '价格',
txtP: '全网最低价，所有资源原价直出，无隐形加价'
},
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark02.png',
number: '02',
txtH3: '资源',
txtP: '全平台覆盖，全行业整合，海量优质资源'
},
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark03.png',
number: '03',
txtH3: '数据',
txtP: '智能大数据系统，精确定位，精准数据输出'
},
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark04.png',
number: '04',
txtH3: '创意',
txtP: '直击人心，匹配品牌调性的刷屏级内容'
},
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark05.png',
number: '05',
txtH3: '技术',
txtP: '后台匹配前端，技术驱动营销，完美效果呈现'
},
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark06.png',
number: '06',
txtH3: '服务',
txtP: '专业团队多对一VIP服务，量身定制推广策略'
},
{
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark07.png',
number: '07',
txtH3: '经验',
txtP: '已为国内外各领域客户完成千万次曝光'
}
]
}
}
}



// WEBPACK FOOTER //
// ./src/components/IndexAdvantages.vue